export default __webpack_public_path__ + "static/1-35b15d6c91831a05923359f03e3f1785.png";